module.exports = __webpack_public_path__ + "img/1555976227.21fd92b4.jpg";